import { connect } from 'react-redux';
import { compose } from 'redux';
import { createQuickUpgrade as createUpgradePurchase } from '../actions';
import { updatePlan } from 'subscriptions/quick/actions';
import { getQuickUpgradePurchase } from 'reducers';
import subscriptionDecorator from 'subscriptions/decorator';
import UpgradePurchase from './UpgradePurchase';

const mapStateToProps = (state, { subId }) => ({
  purchase: getQuickUpgradePurchase(state, subId),
});

const mapDispatchToProps = {
  createUpgradePurchase,
  updatePlan,
}

export default compose(
  subscriptionDecorator,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(UpgradePurchase);
